/**
 * @module api/rebootProxy
 *
 * API function to reboot the remote SSH proxy server used for
 * downloading YouTube videos. The proxy is needed because YouTube
 * blocks SOCKS5 tunneling, so yt-dlp runs directly on the proxy.
 */

import { api } from "@/api/config.js";

/**
 * Send a request to reboot the remote proxy server.
 * This is an admin-only action used when the proxy becomes
 * unresponsive or needs a fresh start.
 *
 * @returns {Promise<Object>} Server response data confirming the reboot
 * @throws {Error} If the reboot request fails, with a message from
 *   the server or a generic fallback message
 */
export const rebootProxy = async () => {
  try {
    const response = await api.post("/admin/reboot-proxy");
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error(
      error.response?.data?.message || "Failed to reboot the proxy",
    );
  }
};
